import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 160 160"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M70.961 8.744C76.001 3.87 84 3.87 89.04 8.744l6.17 5.97a13 13 0 0 0 10.86 3.528l8.502-1.202c6.942-.982 13.413 3.72 14.625 10.626l1.483 8.457a13.002 13.002 0 0 0 6.712 9.237l7.584 4.024c6.194 3.287 8.666 10.894 5.586 17.193l-3.77 7.714a13 13 0 0 0 0 11.418l3.77 7.714c3.08 6.3.608 13.906-5.586 17.193l-7.584 4.024a13 13 0 0 0-6.712 9.237l-1.483 8.457c-1.212 6.907-7.683 11.608-14.625 10.626l-8.502-1.202c-3.97-.562-7.977.74-10.86 3.528l-6.17 5.97c-5.04 4.875-13.038 4.875-18.078 0l-6.17-5.97a12.998 12.998 0 0 0-10.86-3.528l-8.502 1.202c-6.943.982-13.413-3.719-14.625-10.626l-1.483-8.457a13 13 0 0 0-6.712-9.237l-7.584-4.024c-6.194-3.287-8.666-10.894-5.586-17.193l3.77-7.714a13 13 0 0 0 0-11.418l-3.77-7.714c-3.08-6.3-.608-13.906 5.586-17.193l7.584-4.024a13 13 0 0 0 6.712-9.237l1.483-8.457c1.212-6.907 7.683-11.608 14.625-10.626l8.502 1.202a13 13 0 0 0 10.86-3.528l6.17-5.97Z"
    }, null, -1)
  ]))]))
}
export default { render: render }